/* istanbul ignore file */
// noinspection SpellCheckingInspection

export enum BlockType {
  /**
   * @deprecated ?
   */
  ARTICLE_TITLE = 'article__title',
  BYLINE = 'article__byline',
  ATTACHMENT = 'article__attachment',
  DATELINE = 'article__dateline',
  FORM = 'form',
  FRONTPAGE = 'frontpage__module',
  /**
   * @deprecated
   */
  BANNER = 'article__module', // article__module should never be added in admin 2, but should still be supported for old pages
  CARD_SEARCH = 'cardSearch',
  MAP_V2 = 'map_v2',
  MAP = 'map',

  QUOTE = 'article__quote',
  REFERENCES = 'article__references',
  RELATIONS = 'article__relations',
  WIDGET = 'flexible',
  AUDIO = 'article__audio',
  VIDEO = 'article__video',
  TABLE = 'article__table',
  TEXT = 'article__bodytext',
  MEDIA = 'article__media',
  PROGRAM = 'article__program',

  EMPLOYEES_AUTO = 'employees_auto',
  EMPLOYEES_MANUAL = 'employees_manual',
  EVENTS_AUTO = 'events_auto',
  EVENTS_MANUAL = 'events_manual',

  PAGE_LIST_AUTO = 'page_list_auto',
  PAGE_LIST_MANUAL = 'page_list_manual',
  DM_AUTO = 'dm_auto',
  DM_MANUAL = 'dm_manual',
  DM_SCHOOL = 'dm_school',
  /**
   * @deprecated ?
   */
  DIGITALT_MUSEUM = 'digitaltMuseum',

  KP = 'kp',
  KP_OWNER = 'kp_owner',
  /**
   * @deprecated ?
   */
  KULTUR_PUNKT = 'kulturpunkt',

  OPENING_HOURS = 'article__openinghours',
  /**
   * @deprecated ?
   */
  PERSON = 'article__person',
  /**
   * @deprecated
   */
  CALENDAR = 'calendar',
  SHARING = 'article__sharing',
}
